__turbopack_context__.v({
  "chip": "tQa29W_chip",
  "chipDefault": "tQa29W_chipDefault",
  "chipPrimary": "tQa29W_chipPrimary",
  "chipSecondary": "tQa29W_chipSecondary",
  "icon": "tQa29W_icon",
  "iconDefault": "tQa29W_iconDefault",
  "iconPrimary": "tQa29W_iconPrimary",
  "iconSecondary": "tQa29W_iconSecondary",
});
